<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.17075 6.75C6.58258 5.87611 7.69382 5.25 9.00004 5.25C10.6569 5.25 12 6.25736 12 7.5C12 8.54958 11.0418 9.43131 9.74571 9.67995C9.33891 9.75799 9.00004 10.0858 9.00004 10.5M9 12.75H9.0075M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z"
      stroke="#999999"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {};
</script>
